module.exports = __webpack_public_path__ + "static/media/shopify_thumbnail.97742496.png";